module.exports = __webpack_public_path__ + "static/media/audio-articles.b9aeb48a.svg";